import { NarrativeCardCompactSyntheticLayout } from './NarrativeCardCompactSyntheticLayout';

export const NarrativeCardCompactSyntheticLoading = () => {
  return (
    <NarrativeCardCompactSyntheticLayout
      role="presentation"
      aria-label="Loading skeleton"
    >
      <div className="col-span-2 grid grid-cols-[max-content_1fr] items-center gap-x0_75 @7xl:col-span-1">
        <div className="bones size-x4 rounded-full" />
        <div className="grid gap-x0_75">
          <div className="bones h-x3 w-x20 @7xl:h-[30px]" />
          <div className="bones h-x1_25 w-x10 @7xl:h-x1_5" />
        </div>
      </div>

      <div className="grid grid-cols-[max-content_1fr] gap-x1">
        <div className="bones w-x0_5" />
        <div className="grid gap-x0_75">
          <div className="bones h-x3 w-x14 @7xl:h-[30px]" />
          <div className="bones h-x1_25 w-x16 @7xl:h-x1_5" />
        </div>
      </div>
      <div className="grid grid-cols-[max-content_1fr] gap-x1">
        <div className="bones w-x0_5" />
        <div className="grid gap-x0_75">
          <div className="bones h-x3 w-x14 @7xl:h-[30px]" />
          <div className="bones h-x1_25 w-x16 @7xl:h-x1_5" />
        </div>
      </div>

      <div className="bones col-span-2 h-x5 min-w-full max-w-full justify-self-end @7xl:col-span-1 @7xl:min-w-x16" />
    </NarrativeCardCompactSyntheticLayout>
  );
};
